/*
 *  Copyright (c) Qwoach LLC 2026. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 */

import FilterableItem from "@shared/Filterable/FilterableItem";
import {BookLayoutPreferenceEnum} from "@shared/BookWriting/BookLayoutPreferenceEnum";

export default class BookTypeItem extends FilterableItem {

	title: string = null
	description: string = null
	defaultTitle: string = null
	defaultLayoutPreference: BookLayoutPreferenceEnum = BookLayoutPreferenceEnum.ALTERNATE_SIDES
	isSystem: boolean = false

	constructor(options = {}) {
		super(options);
		this.applyOptions(options);
	}

}
